import { type Branded, notEmpty } from '@festina-life/core'
import { NavLink } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import type { FC } from 'react'

import { useHook } from '../../../lenteHooks'
import { withLifeErrorBoundary } from '../../../libs/withLifeErrorBoundary'
import { generalRoutes } from '../../../routing/generalRoutes'
import { IdToPerson } from '../../idToLec/IdToPerson'
import { OverviewItem } from '../../overview/OverviewItem'
import { OverviewSection } from '../../overview/OverviewSection'
import { OverviewTitle } from '../../overview/OverviewTitle'

const RelatedCommitmentSectionInternal: FC = () => {
  const translate = useTranslate()

  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()
  const { data } = useHook('fetchers.life.useFetchDependentCommitments')(
    {
      personId: ownerId,
      tenantId,
      excludeSelf: true,
    },
    {
      select: (data) =>
        data?.personDependentCommitments?.filter(notEmpty) ?? [],
    },
  )

  return data.length > 0 ? (
    <OverviewSection>
      <OverviewTitle>{translate('relatedCommitment.title')}</OverviewTitle>
      {data.map(({ dependentCommitmentId }) =>
        dependentCommitmentId ? (
          <OverviewItem iconName="User" key={dependentCommitmentId}>
            <NavLink
              to={generalRoutes.commitment.workbench({
                tenantId,
                ownerId: dependentCommitmentId,
              })}
              className="flex gap-1"
            >
              <IdToPerson
                id={dependentCommitmentId}
                format="externalId"
                link="never"
              />
              <IdToPerson id={dependentCommitmentId} link="never" />
            </NavLink>
          </OverviewItem>
        ) : null,
      )}
    </OverviewSection>
  ) : null
}

// All sections usually fetches to make sure that something is available.
// But this is different as related commitments has nothing with the current user, but their partners.
// Therefor all customers who has bought the Life component has this.
export const RelatedCommitmentSection = withLifeErrorBoundary(
  RelatedCommitmentSectionInternal,
) as Branded<typeof RelatedCommitmentSectionInternal, 'Area'>
